import { render } from "./Privacy.vue?vue&type=template&id=154fa077&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=154fa077&scoped=true&lang=scss"
import "./Privacy.vue?vue&type=style&index=1&id=154fa077&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154fa077"]])

export default __exports__